<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>
<h2 mat-dialog-title>
  No Response
  <img class="close-button"  (click)="onNoClick()" src="/assets/images/close.png" alt="">
</h2>
<mat-dialog-content>
  <form class="no-response-form" [formGroup]="noresponseForm">
    <div class="mb-3">
      <label for="reasons" class="form-label">No Response Reasons<span class="alert-small">*</span></label>
      <select id="reasons" formControlName="no_response_reason" class="form-select"
      [ngClass]="{ 'is-invalid': submitted && f['no_response_reason'].errors }">
        <option disabled selected value="">Select</option>
        <option *ngFor="let reason of noResponseReason" [value]="reason.id + ':' + reason.reason">{{ reason.reason }}</option>
      </select>
  
      <div  *ngIf="submitted && f['no_response_reason'].errors" class="invalid-feedback">
        <div *ngIf="noresponseForm.get('no_response_reason')?.errors?.['required']" class="error-msg">
            Please Select No Response Reason.
        </div>
    </div>
    </div>
    <div class="mb-3">
      <label for="remarks" class="form-label">Remarks</label>
      <textarea class="form-control" id="remarks" formControlName="remarks" rows="3" placeholder="Enter Text here"></textarea>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="d-flex justify-content-end">
  <button class="btn white-btn mr-2" (click)="onNoClick()">Cancel</button>
  <!-- <button class="btn blue-btn mr-3" (click)="onSubmit()">Submit</button> -->
  <button class="btn blue-btn mr-3" type="submit" (click)="onSubmit()">Submit</button>
</mat-dialog-actions>